import { isDev } from '@pequity/shared/utils/env';

const PlaygroundPage = () => import('@/playground/pages/playground.vue');

export const playgroundRoutes =
  isDev || import.meta.env.VITE_ENVIRONMENT !== 'production'
    ? [{ path: '/playground/:page?', name: 'playground', component: PlaygroundPage }]
    : [];
